module.exports = __webpack_public_path__ + "static/media/reportWhiteIcon.872a9420.svg";